var _path, _path2, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDereDyKraheshe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 179,
    viewBox: "0 0 183 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2952 13.4358H13.7048V165.564H77.2952V13.4358ZM0 0V179H91V0H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.295 13.4358H105.705V165.564H169.295V13.4358ZM92 0V179H183V0H92Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 62,
    height: 151,
    fill: "url(#paint0_linear_841_1759)",
    stroke: "#DEDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 14.5,
    width: 62,
    height: 151,
    fill: "url(#paint1_linear_841_1759)",
    stroke: "#DEDEDE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 79.5,
    width: 4,
    height: 20,
    rx: 2,
    stroke: "#DEDEDE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 151.707,
    y2: -0.5,
    transform: "matrix(0.192908 -0.981217 0.841617 0.540075 107.856 165.358)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 151.94,
    y2: -0.5,
    transform: "matrix(0.200379 0.979718 -0.842901 0.538068 136.035 16.0095)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 93.8221,
    y2: -0.5,
    transform: "matrix(-0.627379 -0.778714 0.35544 -0.934699 167.032 164.134)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 96.3858,
    y2: -0.5,
    transform: "matrix(0.610778 -0.791802 0.369124 0.92938 107.856 92.7239)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 93.6095,
    y2: -0.5,
    transform: "matrix(0.628796 -0.77757 0.363627 0.931545 15.8052 164.418)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 95.2166,
    y2: -0.5,
    transform: "matrix(-0.61824 -0.78599 0.372441 -0.928056 74.981 91.2418)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_841_1759",
    x1: 85.4627,
    y1: -151.892,
    x2: -12.7197,
    y2: 145.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_841_1759",
    x1: 177.463,
    y1: -151.892,
    x2: 79.2803,
    y2: 145.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDereDyKraheshe);
export default __webpack_public_path__ + "static/media/dere-dy-kraheshe.88c256aa0ac3c2fecc673bdc27136abc.svg";
export { ForwardRef as ReactComponent };